

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const MENTORREQUIREMENTGETALL= createAsyncThunk(
  "MentorRequirementGetAll/MentorRequirementGetAll",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const MentorRequirementGetAllSlice = createSlice({
  name: "MentorRequirementGetAllSlice",
  initialState: {
    MentorRequirementGetAll: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfMentorRequirementGetAll: (state) => {
        state.MentorRequirementGetAll.loading = false
        state.MentorRequirementGetAll.error = false
        state.MentorRequirementGetAll.data = []
        state.MentorRequirementGetAll.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(MENTORREQUIREMENTGETALL.fulfilled, (state, action) => {
      state.MentorRequirementGetAll = {
        ...state.MentorRequirementGetAll,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MENTORREQUIREMENTGETALL.pending, (state, action) => {
      state.MentorRequirementGetAll = {
        ...state.MentorRequirementGetAll,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MENTORREQUIREMENTGETALL.rejected, (state, action) => {
      state.MentorRequirementGetAll = {
        ...state.MentorRequirementGetAll,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const MentorRequirementGetAllAction = {
    MENTORREQUIREMENTGETALL,
};

export { MentorRequirementGetAllAction };
export default MentorRequirementGetAllSlice.reducer;
export const {setInitialStateOfMentorRequirementGetAll} = MentorRequirementGetAllSlice.actions
